import {
  useCallback, useMemo, useEffect, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import alarmsActions from '@state/alarms/actions';
import telemetryApi from '@api/telemetryApi';

function useSimpleCondition({ groupIndex, index }) {

  const dispatch = useDispatch();

  const isEditDefault = useSelector(({ alarms }) => alarms.isEditDefault);
  const deviceType = useSelector(({ alarms: a }) => a.createEditValues.device_type);
  const typeAlarm = useSelector(({ alarms: a }) => a.createEditValues.origin);
  const devices = useSelector(({ device: a }) => a.deviceList);
  const orCondition = useSelector(
    ({ alarms: a }) => a.createEditValues.conditions[groupIndex][index],
  );

  const [mapAlarmsFields, setMapAlarmsFields] = useState([]);

  const removeOrCondition = useCallback(() => {

    dispatch(alarmsActions.removeOrCondition(groupIndex, index));

  }, [dispatch, index, groupIndex]);

  const onChangeOrCondition = useCallback(
    (name, value) => {

      console.log('name: ', name);
      console.log('value: ', value);

      if (name !== 'type') {

        // eslint-disable-next-line
        const newParams = (function () {
          const params = { ...orCondition.params, [name]: value };

          if (name === 'field') {

            delete params.value;
            delete params.values;

          }

          return params;

        }());

        dispatch(
          alarmsActions.changeOrCondition(groupIndex, index, {
            ...orCondition,
            params: newParams,
          }),
        );
        return;

      }

      dispatch(
        alarmsActions.changeOrCondition(groupIndex, index, {
          ...orCondition,
          [name]: value,
          params: {},
        }),
      );

    },
    // eslint-disable-next-line
    [orCondition]
  );

  useEffect(() => {

    if (deviceType === '' || deviceType === null || deviceType === undefined) {

      return [];

    }
    const abortController = new AbortController();
    const { signal } = abortController;

    telemetryApi.getAllDeviceField({ signal, device_type: deviceType })
      .then((response) => {

        setMapAlarmsFields(response);

      })
      .catch((error) => {

        // eslint-disable-next-line
        console.log('error: ', error); 
        setMapAlarmsFields([]);

      });

    return [];
    // eslint-disable-next-line
  }, [deviceType]);

  const filterFields = useMemo(() => {

    let array = [];
    switch (typeAlarm) {

      case 'Inst-Telemetry-Other':
        array = mapAlarmsFields.map((item) => ({ ...item, inputNumberProps: { step: '0.00', unit: ' ' } }));
        break;
      case 'Missing':
        // array = devices.map((device) => ({ edge_name: device.name, name: device.name }));
        array = [];
        break;
      case 'Device-Disconnection':
        // array = devices.map((device) => ({ edge_name: device.name, name: device.name }));
        array = [];
        break;
      default:
        array = [];
        break;

    }

    return array;

  }, [typeAlarm, mapAlarmsFields, devices]);

  return {
    orCondition,
    removeOrCondition,
    onChangeOrCondition,
    filterFields,
    isEditDefault,
    typeAlarm,
    deviceType,
  };

}

export default useSimpleCondition;
